// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2ebQQ","hidden":"_329IV","overlay":"_27pui","active":"_2FFW8","poster":"_2adYu","icon":"_3L7EJ","transparency":"_2eT8q"};